// Captain pool for BvB round robin / one-v-many.
// The UI is a single multiselect holding two kinds of item: a whole box (carries
// .decks) or a single captain. Everything here is pure so it can be tested.

// Captains with a bot chart, bucketed by the box they belong to. A captain in two
// boxes is listed under the first, so it can't appear twice in the picker.
export function poolGroups(available, charts, sets){
    let bots = (available || []).filter(c => charts && charts.hasOwnProperty(c));
    let groups = [];
    let seen = [];
    for(let s of (sets || [])){
        let decks = (s.decks || []).filter(d => bots.includes(d) && !seen.includes(d));
        if(decks.length == 0) continue;
        seen = [...seen, ...decks];
        groups.push({name: s.name, decks});
    }
    let ungrouped = bots.filter(c => !seen.includes(c)); // captains whose box we don't know
    if(ungrouped.length > 0) groups.push({name: 'Other', decks: ungrouped});
    return groups;
}

export function poolItems(groups){
    let items = [];
    for(let g of (groups || [])){
        items.push({value: `box:${g.name}`, label: g.name, group: g.name, decks: g.decks});
        for(let c of g.decks) items.push({value: c, label: c, group: g.name});
    }
    return items;
}

// A box chip already covers its captains, so drop any that are individually picked too
export function tidySelection(sel){
    let covered = (sel || []).filter(i => i.decks).flatMap(i => i.decks);
    return (sel || []).filter(i => i.decks || !covered.includes(i.value));
}

export function poolFromSelection(sel){
    let out = [];
    for(let i of (sel || [])){
        for(let c of (i.decks || [i.value])) if(!out.includes(c)) out.push(c);
    }
    return out;
}

// Same chosen items, ignoring order? Used to stop a re-assignment feeding
// svelte-select's own value churn back into an update loop.
export function sameSelection(a, b){
    let ids = s => (s || []).map(i => i.value).sort().join('|');
    return ids(a) === ids(b);
}
